/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { PostUsersAuthMutationRequest, PostUsersAuthMutationResponse, PostUsersAuth400 } from '../entities/PostUsersAuth'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { postUsersAuth } from '../api/postUsersAuth'
import { useMutation } from '@tanstack/react-query'

export const postUsersAuthMutationKey = () => [{ url: '/users/auth' }] as const

export type PostUsersAuthMutationKey = ReturnType<typeof postUsersAuthMutationKey>

/**
 * @description Аутентификация клиентов
 * @summary Аутентификация
 * {@link /users/auth}
 */
export function usePostUsersAuth<TContext>(
  options: {
    mutation?: UseMutationOptions<PostUsersAuthMutationResponse, ResponseErrorConfig<PostUsersAuth400>, { data: PostUsersAuthMutationRequest }, TContext> & {
      client?: QueryClient
    }
    client?: Partial<RequestConfig<PostUsersAuthMutationRequest>> & { client?: typeof client }
  } = {},
) {
  const { mutation: { client: queryClient, ...mutationOptions } = {}, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? postUsersAuthMutationKey()

  return useMutation<PostUsersAuthMutationResponse, ResponseErrorConfig<PostUsersAuth400>, { data: PostUsersAuthMutationRequest }, TContext>(
    {
      mutationFn: async ({ data }) => {
        return postUsersAuth(data, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}